'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slateEditList = require('@gitbook/slate-edit-list');

var _slateEditList2 = _interopRequireDefault(_slateEditList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditListPlugin = (0, _slateEditList2.default)({
  types: ['ol_list', 'ul_list', 'pattern__examples', 'pattern__conversation', 'pattern__center', 'pattern__watchout', 'pattern__cultural', 'pattern__note']
});

exports.default = EditListPlugin;